module.exports = __webpack_public_path__ + "img/block-768.90511f33.jpg";